import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { closeModal, toggleModal } from "../features/modalSlice";
import useOutsideClick from "../hooks/useOutsideClick";
import { AppDispatch } from "../app/store";
import { ModalDeleteChatProps } from "../types";
import { deleteChat, deleteFolder } from "../features/folderSlice";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const ModalDeleteChat: React.FC<ModalDeleteChatProps> = ({ id = 0, type = "chat" }) => {
  const dispatch = useDispatch<AppDispatch>();
  const modalRef = useRef<HTMLDivElement | null>(null); // Define the type explicitly
  // Handle the delete action
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      let message = "";
      if (type === "chat") {
        message = await dispatch(deleteChat(id)).unwrap(); // Get the success message
        dispatch(toggleModal());
      } else if (type === "folder") {
        message = await dispatch(deleteFolder(id)).unwrap(); // Get the success message
        dispatch(toggleModal());
      }

      toast.success(message, {
        className:
          "md:!bg-[#00B21B]/20 !bg-[#00B21B]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    } catch (error) {
      toast.error((error as string) || "To delete this folder, you must first delete the chats.", {
        className:
          "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }

    dispatch(closeModal("ModalDeleteChat"));
    navigate("/chat");
  };

  // Close modal on outside click
  useOutsideClick({
    modalRef,
    closeAction: () => dispatch(closeModal("ModalDeleteChat")),
  });

  return (
    <div className="fixed inset-0 flex items-center justify-center backdrop-blur-[7px] z-50 w-[100vw] h-[100vh]">
      <div
        className="dark:bg-[#061d2f] bg-lightBg/80 backdrop-blur-[42px] rounded-3xl w-[572px] h-[182px]"
        ref={modalRef}
      >
        {/* Modal Content */}
        <h2 className="text-base px-6 pt-4 pb-1 dark:text-white text-black font-bold font-ProximaLight ">
          Delete {type}
        </h2>
        <div className="flex flex-col px-6 py-3 text-white">
          <p className="text-base font-ProximaLight dark:text-[#ffffffba] text-black">
            Are you sure you want to delete this <b>{type}</b>?
          </p>
          <p className="text-sm font-extralight mt-1 dark:text-[#ffffff6e] text-black">
            This cannot be undone.
          </p>
          <div className="flex justify-end mt-4">
            <button
              onClick={() => dispatch(closeModal("ModalDeleteChat"))}
              className="bg-transparent dark:hover:bg-[#5f829f73] hover:bg-[#191919] transition-colors duration-200 ease hover:text-white border dark:border-[#5f829f73] border-[#191919]  rounded-lg dark:text-white text-[#191919] text-sm font-ProximaLight h-[39px] w-[87px] mr-3"
            >
              Cancel
            </button>
            <button
              onClick={handleDelete}
              className="bg-[#FD7272] border border-[#FD7272] hover:bg-transparent transition-colors duration-200 ease hover:text-[#FD7272] rounded-lg text-white text-sm font-ProximaLight h-[39px] w-[87px]"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDeleteChat;
